import { ConciliationDto } from './conciliation.dto';
import { CorporateAccountDto } from './corporate-account.dto';
import { CurrencyDto } from './currency.dto';
import { FinalitiesDto } from './finalities.dto';
import { IndividualAccountDto } from './individual-account.dto';
import { OrderSettlementDto } from './order-settlement.dto';
import { QuotationDto } from './quotation.dto';
import { ReceiverDto } from './receiver.dto';
import { SenderDto } from './sender.dto';

export class InboundOrderDto {
  id: number;
  amount: number;
  approved: boolean;
  repprovedWithCorrection: boolean;
  repprovedWithoutCorrection: boolean;
  amountME: number;
  amountMN: number;
  protocoloDI: string;
  numeroDI: string;
  aba: string;
  iban: string;
  vet: string;
  tax: number;
  quotations: QuotationDto[];
  individualAccount: IndividualAccountDto;
  effectiveAmount: number;
  tipoPessoa: string;
  settlementDate: string;
  reprovedMsg: string;
  corporateAccountId: number;
  createdDate: string;
  corporateAccount: CorporateAccountDto;
  currency: CurrencyDto;
  conciliations: ConciliationDto[];
  conciliation: ConciliationDto;
  description: string;
  rate: number;
  dueDate: string;
  remmitanceType: string;
  finality: FinalitiesDto;
  slipCode: string;
  invoiceReceiverLogo: boolean;
  orderAttachments: OrderAttachmentDto[];
  receiver: {
    account: string;
    branch: string;
    id: number;
    name: string;
    address: string;
    intermediarySwift: string;
    intermediaryBank: string;
    intermediaryAccount: string;
    bankChannel: string;
    documentType: string;
    email: string;
    bankName: string;
    documentNumber: string;
    country: string;
    swift: string;
  };
  sender: {
    country: string;
    companyName: string;
    bankName: string;
    bankAgency: string;
    bankAccount: string;
    id: number;
    branch: string;
    email: string;
    favorite: boolean;
    copyInvoiceEmail: boolean;
  };
  status: string;
  statusFlow: string;
  proofOperationFileData: string;
  orderSettlement: OrderSettlementDto;

  constructor() { }
}

export class OrderAttachmentDto {
  id: number;
  fileName: string;
  logicFile: boolean;
  orderId: number;
  isClickedRepprove?: boolean = false;
  isClickedApprove?: boolean = false;
  isClicked?: boolean = false;
  approved: boolean = null;
}



export class OrderDto {
  id: number;
  finality: FinalitiesDto;
  receiver: ReceiverDto;
  amount: number;
  currency: string;
  protocoloDI: string;
  numeroDI: string;
  status: string;
  statusFlow: string;
  dueDate: string;
  createdBy: string;
  createdDate: string;
  sender: SenderDto;
  lastModifiedBy: string;
  lastModifiedDate: string;
  remmitanceType: string;
  corporateAccountId: number;
  orderAttachments: OrderAttachmentDto[];
  conciliations: ConciliationDto[];
  quotations: QuotationDto[];
  corporateAccount: CorporateAccountDto;

  constructor() { }
}
